// src/components/TaskAnexos.jsx
import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import "./Task.css";
import "./AtaObjetivos.css";
import { supabase } from "../supabaseClient";
import { FaTrashAlt } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faUserPlus, faCalendar, faTasks, faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import TaskCompromissos from "./TaskCompromissos"; // ← PATCH 1

const podeDesmarcarConclusao = (concluidoEm) => {
  if (!concluidoEm) return true;
  return (new Date() - new Date(concluidoEm)) / (1000 * 60 * 60) < 24;
};

const gerarAbreviacao = (nome) => {
  if (!nome) return "?";
  if (nome.includes('_')) return nome.split('_').map(p => p.charAt(0).toUpperCase()).join('_');
  if (nome.includes(' ')) return nome.split(' ').filter(p => p.length > 0).map(p => p.charAt(0).toUpperCase()).join('');
  return nome.substring(0, 2).charAt(0).toUpperCase() + nome.substring(1, 2).toLowerCase();
};

const ComentarioIcon = ({ onClick, title, hasComments }) => {
  const cor = hasComments ? '#10b981' : '#9ca3af';
  return (
    <svg
      width="16" height="16" viewBox="0 0 24 24" fill="none"
      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
      className="obj-icon-acao-svg"
      style={{ cursor: 'pointer', stroke: cor }}
      onClick={onClick} title={title}
    >
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  );
};

const ChipResponsavel = ({ responsavel, onRemove, disabled }) => {
  const nomeExibicao = responsavel.nome_exibicao || "Usuário";
  const isExterno    = !responsavel.usuario_id;
  const avatarUrl    = responsavel.avatar_url;
  const abreviacao   = gerarAbreviacao(nomeExibicao);

  return (
    <span className={`chip-resp-mini ${isExterno ? 'chip-resp-mini--ext' : ''}`} title={nomeExibicao}>
      {avatarUrl && !isExterno ? (
        <img
          src={avatarUrl}
          alt={nomeExibicao}
          className="chip-resp-mini-img"
          onError={e => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }}
        />
      ) : null}
      <div className="chip-resp-mini-iniciais" style={{ display: avatarUrl && !isExterno ? 'none' : 'flex' }}>
        {abreviacao}
      </div>
      {!disabled && (
        <span className="chip-resp-mini-remove" onClick={e => { e.stopPropagation(); onRemove(responsavel); }}>×</span>
      )}
      <div className="chip-resp-tooltip">
        <strong>{nomeExibicao}</strong>
        {isExterno && <em>Externo</em>}
      </div>
    </span>
  );
};

const formatarDataParaExibicao = (dataString) => {
  if (!dataString) return '';
  const dataParte = dataString.split('T')[0];
  const [ano, mes, dia] = dataParte.split('-');
  return `${dia}/${mes}/${ano}`;
};

const UploadSpinner = ({ label }) => (
  <div className="upload-spinner-row">
    <div className="upload-spinner" />
    <span className="upload-spinner-label">{label}</span>
  </div>
);

const MiniaturaLoading = ({ fileName }) => (
  <div className="miniatura-item miniatura-loading">
    <div className="miniatura-loading-overlay">
      <div className="upload-spinner upload-spinner--mini" />
    </div>
    <div className="miniatura-loading-name">{fileName}</div>
  </div>
);

const AnexoLoading = ({ fileName }) => (
  <div className="anexo-item anexo-item--loading">
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <div className="upload-spinner upload-spinner--mini" />
      <span style={{ color: "#9ca3af", fontSize: 13 }}>{fileName}</span>
    </div>
    <span style={{ fontSize: 11, color: "#b0b7c3" }}>enviando…</span>
  </div>
);

const TaskAnexos = ({
  notaAtual,
  userId,
  loading,
  anexosSalvos,
  setAnexosSalvos,
  objetivos,
  setObjetivos,
  showObjetivos,
  setShowObjetivos,
  novoObjetivoTexto,
  setNovoObjetivoTexto,
  inputResponsavel,
  setInputResponsavel,
  sugestoesResponsavel,
  setSugestoesResponsavel,
  containerId,
  setImagemAmpliada,
  onNovoComentario,   // ← PATCH 2
}) => {
  const [editingResponsavelId, setEditingResponsavelId] = React.useState(null);
  const dateInputRefs = React.useRef({});

  const [uploadingImages, setUploadingImages] = React.useState([]);
  const [uploadingFiles, setUploadingFiles]   = React.useState([]);

  // ── Estados portados do AtaObjetivos ──
  const [comentariosObjetivo, setComentariosObjetivo]   = useState({});
  const [editandoComentario, setEditandoComentario]     = useState({});
  const [comentarioTemp, setComentarioTemp]             = useState({});
  const [enviandoComentario, setEnviandoComentario]     = useState({});
  const [meuNome, setMeuNome]                           = useState("Você");
  const [reprogramacoesPorObjetivo, setReprogramacoesPorObjetivo] = useState({});
  const [historicoAberto, setHistoricoAberto]           = useState({});
  const [filtroResponsavel, setFiltroResponsavel]       = useState(null);
  const [filtroStatus, setFiltroStatus]                 = useState(null); // 'concluidos' | 'nao_respondidos' | 'sem_resp' | null
  const [filtroStatusAberto, setFiltroStatusAberto]     = useState(false);
  const filtroStatusRef = useRef(null);
  const [ordemDesc, setOrdemDesc] = useState(() => {
  const salvo = localStorage.getItem("objetivos_ordem_desc");
  return salvo !== null ? salvo === "true" : true;
});

const [showCompromissos, setShowCompromissos] = useState(false); // ← PATCH 4
const [compromissosCount, setCompromissosCount] = useState(0); // ← NOVO ESTADO PARA CONTAGEM

// ← NOVO useEffect PARA CARREGAR CONTAGEM DE COMPROMISSOS
useEffect(() => {
  if (!notaAtual?.id) return;
  const carregarContagem = async () => {
    const { data, error } = await supabase
      .from("compromissos")
      .select("id")
      .eq("nota_id", notaAtual.id);
    if (!error) setCompromissosCount(data?.length || 0);
  };
  carregarContagem();
}, [notaAtual?.id]);

useEffect(() => {
  localStorage.setItem("objetivos_ordem_desc", String(ordemDesc));
}, [ordemDesc]);

  const carregouExtrasRef = useRef(new Set());

  useEffect(() => {
    if (!userId) return;
    supabase.from("profiles").select("nome").eq("id", userId).single()
      .then(({ data }) => { if (data?.nome) setMeuNome(data.nome); });
  }, [userId]);

  useEffect(() => {
    const handle = (e) => { if (filtroStatusRef.current && !filtroStatusRef.current.contains(e.target)) setFiltroStatusAberto(false); };
    if (filtroStatusAberto) { document.addEventListener("mousedown", handle); return () => document.removeEventListener("mousedown", handle); }
  }, [filtroStatusAberto]);

  // ── Carregar comentários + reprogramações + avatar dos responsáveis para objetivos ainda não carregados ──
  useEffect(() => {
    const idsParaCarregar = objetivos
      .map(o => o.id)
      .filter(id => id && !carregouExtrasRef.current.has(id));
    if (!idsParaCarregar.length) return;
    idsParaCarregar.forEach(id => carregouExtrasRef.current.add(id));

    (async () => {
      const { data: comentariosData } = await supabase
        .from("checklist_item_comentarios").select("*").in("checklist_item_id", idsParaCarregar)
        .order("created_at", { ascending: true });
      if (comentariosData?.length) {
        const userIds = [...new Set(comentariosData.map(c => c.usuario_id))];
        const { data: profiles } = await supabase.from("profiles").select("id, nome").in("id", userIds);
        const profilesMap = (profiles || []).reduce((acc, p) => { acc[p.id] = p.nome; return acc; }, {});
        setComentariosObjetivo(prev => {
          const novo = { ...prev };
          for (const c of comentariosData) {
            const enriched = { ...c, profiles: { nome: profilesMap[c.usuario_id] || "Usuário" } };
            if (!novo[c.checklist_item_id]) novo[c.checklist_item_id] = [];
            novo[c.checklist_item_id] = [...novo[c.checklist_item_id], enriched];
          }
          return novo;
        });
      }

      const { data: reprogData } = await supabase
        .from("checklist_item_reprogramacoes").select("*").in("checklist_item_id", idsParaCarregar)
        .order("alterado_em", { ascending: false });
      if (reprogData?.length) {
        setReprogramacoesPorObjetivo(prev => {
          const novo = { ...prev };
          for (const r of reprogData) {
            if (!novo[r.checklist_item_id]) novo[r.checklist_item_id] = [];
            novo[r.checklist_item_id] = [...novo[r.checklist_item_id], r];
          }
          return novo;
        });
      }

      const respSemAvatar = objetivos
        .flatMap(o => o.responsaveis || [])
        .filter(r => r.usuario_id && !r.avatar_url);
      if (respSemAvatar.length) {
        const userIds = [...new Set(respSemAvatar.map(r => r.usuario_id))];
        const { data: profiles } = await supabase.from("profiles").select("id, avatar_url").in("id", userIds);
        const avatarMap = (profiles || []).reduce((acc, p) => { acc[p.id] = p.avatar_url; return acc; }, {});
        setObjetivos(prev => prev.map(o => ({
          ...o,
          responsaveis: (o.responsaveis || []).map(r => r.usuario_id && !r.avatar_url ? { ...r, avatar_url: avatarMap[r.usuario_id] || null } : r)
        })));
      }
    })();
  }, [objetivos, setObjetivos]);

  const handleAddImagens = async (e) => {
    const files = Array.from(e.target.files || []).filter(f => f.type.startsWith('image/'));
    if (!notaAtual?.id || !userId || files.length === 0) return;

    const placeholders = files.map(f => ({ tempId: crypto.randomUUID(), fileName: f.name }));
    setUploadingImages(prev => [...prev, ...placeholders]);

    try {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const placeholder = placeholders[i];

        const sanitize = (name) => name
          .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-zA-Z0-9._-]/g, '_').replace(/_+/g, '_')
          .trim().replace(/^_+|_+$/g, '');

        const safeName = sanitize(file.name);
        const fileName = `anexos/${notaAtual.id}_${Date.now()}_${safeName}`;

        const { error: uploadError } = await supabase.storage.from("anexos").upload(fileName, file);
        if (uploadError) throw uploadError;

        const { data } = supabase.storage.from("anexos").getPublicUrl(fileName);

        const { data: insertedAnexo } = await supabase
          .from("anexos")
          .insert({
            nota_id: notaAtual.id,
            user_id: userId,
            file_name: file.name,
            file_url: data.publicUrl,
            mime_type: file.type || 'image/unknown',
          })
          .select()
          .single();

        setUploadingImages(prev => prev.filter(p => p.tempId !== placeholder.tempId));
        setAnexosSalvos(prev => [...prev, insertedAnexo]);
      }
    } catch (err) {
      console.error("Erro ao enviar imagem:", err);
      alert("Erro ao enviar uma ou mais imagens.");
      setUploadingImages([]);
    }

    e.target.value = "";
  };

  const handleAddAnexos = async (e) => {
    const files = Array.from(e.target.files || []).filter(f => !f.type.startsWith('image/'));
    if (!notaAtual?.id || !userId || files.length === 0) return;

    const placeholders = files.map(f => ({ tempId: crypto.randomUUID(), fileName: f.name }));
    setUploadingFiles(prev => [...prev, ...placeholders]);

    try {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const placeholder = placeholders[i];

        const sanitize = (name) => name
          .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          .replace(/[^a-zA-Z0-9._-]/g, '_').replace(/_+/g, '_')
          .trim().replace(/^_+|_+$/g, '');

        const safeName = sanitize(file.name);
        const fileName = `anexos/${notaAtual.id}_${Date.now()}_${safeName}`;

        const { error: uploadError } = await supabase.storage.from("anexos").upload(fileName, file);
        if (uploadError) throw uploadError;

        const { data } = supabase.storage.from("anexos").getPublicUrl(fileName);

        const { data: insertedAnexo } = await supabase
          .from("anexos")
          .insert({
            nota_id: notaAtual.id,
            user_id: userId,
            file_name: file.name,
            file_url: data.publicUrl,
            mime_type: file.type || null,
          })
          .select()
          .single();

        setUploadingFiles(prev => prev.filter(p => p.tempId !== placeholder.tempId));
        setAnexosSalvos(prev => [...prev, insertedAnexo]);
      }
    } catch (err) {
      console.error("Erro ao enviar anexo:", err);
      alert("Erro ao enviar um ou mais anexos.");
      setUploadingFiles([]);
    }

    e.target.value = "";
  };

  const handleRemoverAnexo = async (anexoId, fileUrl) => {
    if (!window.confirm("Deseja realmente excluir este anexo?")) return;
    try {
      const url = new URL(fileUrl);
      const fileName = url.pathname.split("/").pop();
      await supabase.storage.from("anexos").remove([fileName]);
      await supabase.from("anexos").delete().eq("id", anexoId).eq("user_id", userId);
      setAnexosSalvos(prev => prev.filter(a => a.id !== anexoId));
    } catch (err) {
      console.error("Erro ao excluir anexo:", err);
      alert("Erro ao excluir anexo.");
    }
  };

  const criarChecklistSeNecessario = async () => {
    if (!notaAtual?.id || !containerId) return null;
    const { data: checklist } = await supabase
      .from("checklists").select("id").eq("nota_id", notaAtual.id).single();
    if (checklist) return checklist.id;
    const { data: novo, error: insertError } = await supabase
      .from("checklists").insert({ nota_id: notaAtual.id, container_id: containerId }).select("id").single();
    if (insertError || !novo) {
      alert("Você não tem permissão para criar checklist neste container.");
      return null;
    }
    return novo.id;
  };

  const adicionarObjetivo = async () => {
    if (!novoObjetivoTexto.trim()) return;
    try {
      const checklistId = await criarChecklistSeNecessario();
      if (!checklistId) return;
      const { data: item, error } = await supabase
        .from("checklist_items")
        .insert({ checklist_id: checklistId, description: novoObjetivoTexto.trim(), is_completed: false, data_entrega: null, ordem: objetivos.length })
        .select().single();
      if (error) { alert("Erro ao salvar objetivo: " + (error.message || "")); return; }
      if (!item) { alert("Erro inesperado: objetivo não retornado."); return; }
      setObjetivos(prev => [...prev, { id: item.id, texto: item.description, concluido: item.is_completed, concluidoEm: null, dataEntrega: item.data_entrega, responsaveis: [], checklist_id: checklistId }]);
      setNovoObjetivoTexto("");
    } catch (err) {
      console.error("Erro ao adicionar objetivo:", err);
      alert("Erro inesperado ao adicionar objetivo.");
    }
  };

  const toggleConclusao = async (id, concluidoAtual) => {
    const novoValor = !concluidoAtual;
    const objetivo = objetivos.find(o => o.id === id);
    if (concluidoAtual && !podeDesmarcarConclusao(objetivo?.concluidoEm)) {
      alert("Não é possível desmarcar um objetivo concluído há mais de 24 horas.");
      return;
    }
    const agora = new Date();
    setObjetivos(prev => prev.map(o => o.id === id ? { ...o, concluido: novoValor, concluidoEm: novoValor ? agora : null } : o));
    try {
      await supabase.from("checklist_items").update({ is_completed: novoValor, concluido_em: novoValor ? agora.toISOString() : null }).eq("id", id);
    } catch (err) {
      setObjetivos(prev => prev.map(o => o.id === id ? { ...o, concluido: concluidoAtual } : o));
    }
  };

  const atualizarDataEntrega = async (id, novaData) => {
    const objetivo = objetivos.find(o => o.id === id);
    const dataAnterior = objetivo?.dataEntrega || null;
    setObjetivos(prev => prev.map(o => o.id === id ? { ...o, dataEntrega: novaData } : o));
    try {
      await supabase.from("checklist_items").update({ data_entrega: novaData || null }).eq("id", id);
      if (dataAnterior && novaData && dataAnterior !== novaData) {
        const { data: registro, error } = await supabase.from("checklist_item_reprogramacoes")
          .insert({ checklist_item_id: id, data_anterior: dataAnterior, data_nova: novaData, alterado_por: userId })
          .select().single();
        if (!error && registro) {
          setReprogramacoesPorObjetivo(prev => ({ ...prev, [id]: [registro, ...(prev[id] || [])] }));
        }
      }
    } catch (err) { console.error("Erro ao atualizar data:", err); }
  };

  const removerObjetivo = async (id) => {
    if (!window.confirm("Deseja realmente excluir este objetivo?")) return;
    setObjetivos(prev => prev.filter(o => o.id !== id));
    try { await supabase.from("checklist_items").delete().eq("id", id); } catch (err) { console.error(err); }
  };

  const handleResponsavelInputChange = (e, objetivoId) => {
    const valor = e.target.value;
    setInputResponsavel(prev => ({ ...prev, [objetivoId]: valor }));
    if (valor.startsWith("@") && valor.length > 1 && containerId) {
      const termo = valor.slice(1).toLowerCase();
      supabase.from("convites").select("user_id").eq("container_id", containerId).eq("status", "aceito")
        .then(async ({ data: convites }) => {
          const userIds = convites?.map(c => c.user_id).filter(Boolean) || [];
          if (userIds.length === 0) { setSugestoesResponsavel(prev => ({ ...prev, [objetivoId]: [] })); return; }
          const { data: profiles } = await supabase.from("profiles").select("id, nickname, nome").in("id", userIds);
          const sugestoes = profiles?.filter(p => (p.nickname?.toLowerCase().includes(termo)) || (p.nome?.toLowerCase().includes(termo))) || [];
          setSugestoesResponsavel(prev => ({ ...prev, [objetivoId]: sugestoes.slice(0, 10) }));
        });
    } else {
      setSugestoesResponsavel(prev => ({ ...prev, [objetivoId]: [] }));
    }
  };

  const adicionarResponsavelExterno = async (nome, objetivoId) => {
    if (!nome.trim()) return;
    const item = objetivos.find(o => o.id === objetivoId);
    if (!item || item.concluido) return;
    if (item.responsaveis.some(r => r.nome_externo === nome && !r.usuario_id)) return;
    try {
      const { data } = await supabase.from("checklist_responsaveis").insert({ checklist_item_id: objetivoId, nome_externo: nome.trim(), usuario_id: null }).select().single();
      if (!data) return;
      setObjetivos(prev => prev.map(o => o.id === objetivoId ? { ...o, responsaveis: [...o.responsaveis, { id: data.id, nome_externo: nome.trim(), nome_exibicao: nome.trim(), usuario_id: null }] } : o));
      setInputResponsavel(prev => ({ ...prev, [objetivoId]: "" }));
    } catch (err) { console.error(err); }
  };

  const adicionarResponsavelInterno = async (perfil, objetivoId) => {
    const item = objetivos.find(o => o.id === objetivoId);
    if (!item || item.concluido) return;
    if (item.responsaveis.some(r => r.usuario_id === perfil.id)) return;
    try {
      const { data } = await supabase.from("checklist_responsaveis").insert({ checklist_item_id: objetivoId, usuario_id: perfil.id, nome_externo: null }).select().single();
      if (!data) return;
      const { data: profileData } = await supabase.from("profiles").select("avatar_url").eq("id", perfil.id).single();
      setObjetivos(prev => prev.map(o => o.id === objetivoId ? { ...o, responsaveis: [...o.responsaveis, { id: data.id, usuario_id: perfil.id, nome_exibicao: perfil.nome || perfil.nickname || "Usuário", nome: perfil.nome, nickname: perfil.nickname, avatar_url: profileData?.avatar_url || null }] } : o));
      setInputResponsavel(prev => ({ ...prev, [objetivoId]: "" }));
      setSugestoesResponsavel(prev => ({ ...prev, [objetivoId]: [] }));
    } catch (err) { console.error(err); }
  };

  const removerResponsavel = async (responsavelId, objetivoId) => {
    setObjetivos(prev => prev.map(o => o.id === objetivoId ? { ...o, responsaveis: o.responsaveis.filter(r => r.id !== responsavelId) } : o));
    try { await supabase.from("checklist_responsaveis").delete().eq("id", responsavelId); } catch (err) { console.error(err); }
  };

  const enviarComentario = async (objetivoId) => {
    const comentario = comentarioTemp[objetivoId]?.trim();
    if (!comentario || !userId) return;
    if (enviandoComentario[objetivoId]) return;
    setEnviandoComentario(prev => ({ ...prev, [objetivoId]: true }));
    const tempId = `temp-${Date.now()}`;
    setComentariosObjetivo(prev => ({ ...prev, [objetivoId]: [...(prev[objetivoId] || []), { id: tempId, checklist_item_id: objetivoId, usuario_id: userId, comentario, created_at: new Date().toISOString(), profiles: { nome: meuNome } }] }));
    setComentarioTemp(prev => ({ ...prev, [objetivoId]: "" }));
    try {
      const { data, error } = await supabase.from("checklist_item_comentarios").insert({ checklist_item_id: objetivoId, usuario_id: userId, comentario }).select().single();
      if (error) throw error;
      const { data: profile } = await supabase.from("profiles").select("nome").eq("id", userId).single();
      setComentariosObjetivo(prev => ({ ...prev, [objetivoId]: prev[objetivoId].map(c => c.id === tempId ? { ...data, profiles: { nome: profile?.nome || meuNome } } : c) }));
    } catch (err) {
      console.error("Erro ao enviar comentário:", err);
      setComentariosObjetivo(prev => ({ ...prev, [objetivoId]: prev[objetivoId].filter(c => c.id !== tempId) }));
      setComentarioTemp(prev => ({ ...prev, [objetivoId]: comentario }));
      alert("Erro ao enviar comentário.");
    } finally { setEnviandoComentario(prev => ({ ...prev, [objetivoId]: false })); }
  };

  const removerComentario = async (comentario, objetivoId) => {
    if (!comentario?.id || String(comentario.id).startsWith('temp-')) return;
    if (comentario.usuario_id !== userId) return;
    if (!window.confirm("Excluir este comentário?")) return;
    try {
      const { error } = await supabase.from("checklist_item_comentarios").delete().eq("id", comentario.id);
      if (error) throw error;
      setComentariosObjetivo(prev => ({ ...prev, [objetivoId]: prev[objetivoId].filter(c => c.id !== comentario.id) }));
    } catch (err) {
      console.error("Erro ao excluir comentário:", err);
      alert("Erro ao excluir comentário.");
    }
  };

  const todosResponsaveis = useMemo(() => {
    const seen = new Set(); const lista = [];
    for (const obj of objetivos) {
      for (const resp of (obj.responsaveis || [])) {
        const key = resp.usuario_id || resp.nome_externo;
        if (key && !seen.has(key)) { seen.add(key); lista.push(resp); }
      }
    }
    return lista;
  }, [objetivos]);

  const objetivosFiltrados = useMemo(() => {
    let lista = objetivos;

    if (filtroResponsavel) {
      lista = lista.filter(obj =>
        (obj.responsaveis || []).some(r => (r.usuario_id && r.usuario_id === filtroResponsavel) || (!r.usuario_id && r.nome_externo === filtroResponsavel))
      );
    }

    if (filtroStatus === "concluidos") {
      lista = lista.filter(obj => obj.concluido);
    } else if (filtroStatus === "nao_respondidos") {
      lista = lista.filter(obj => !obj.concluido && (comentariosObjetivo[obj.id]?.length || 0) === 0);
    } else if (filtroStatus === "sem_resp") {
      lista = lista.filter(obj => (obj.responsaveis || []).length === 0);
    }

    return lista;
  }, [objetivos, filtroResponsavel, filtroStatus, comentariosObjetivo]);

  const handleDragEnd = async (result) => {
    if (!result.destination || result.source.index === result.destination.index) return;
    const listaBase = objetivosFiltrados;
    const n = listaBase.length;
    const sourceIdx = ordemDesc ? (n - 1 - result.source.index) : result.source.index;
    const destIdx   = ordemDesc ? (n - 1 - result.destination.index) : result.destination.index;
    const reordenada = Array.from(listaBase);
    const [moved] = reordenada.splice(sourceIdx, 1);
    reordenada.splice(destIdx, 0, moved);

    let novaLista;
    if (filtroResponsavel || filtroStatus) {
      novaLista = [...objetivos];
      let ri = 0;
      for (let idx = 0; idx < novaLista.length; idx++) {
        if (objetivosFiltrados.some(f => f.id === novaLista[idx].id)) novaLista[idx] = reordenada[ri++];
      }
    } else {
      novaLista = reordenada;
    }
    setObjetivos(novaLista);
    try {
      const updates = novaLista.map((obj, idx) => ({ id: obj.id, ordem: idx }));
      await Promise.all(updates.map(u => supabase.from("checklist_items").update({ ordem: u.ordem }).eq("id", u.id)));
    } catch (err) { console.error("Erro ao salvar ordem:", err); }
  };

  const progressoPercent = objetivos.length
    ? Math.round((objetivos.filter(o => o.concluido).length / objetivos.length) * 100)
    : 0;

  const imagens = anexosSalvos.filter(a => a.mime_type?.startsWith('image/'));
  const isUploading = uploadingImages.length > 0 || uploadingFiles.length > 0;

  return (
    <>
      <div
        className="anexos-section"
        onDragOver={(e) => e.preventDefault()}
        onDragEnter={(e) => { e.preventDefault(); e.currentTarget.classList.add('drag-over'); }}
        onDragLeave={(e) => { e.preventDefault(); e.currentTarget.classList.remove('drag-over'); }}
        onDrop={(e) => {
          e.preventDefault();
          e.currentTarget.classList.remove('drag-over');
          const files = Array.from(e.dataTransfer.files || []);
          if (files.length > 0) {
            const images = files.filter(f => f.type.startsWith('image/'));
            const others = files.filter(f => !f.type.startsWith('image/'));
            if (images.length > 0) handleAddImagens({ target: { files: images }, preventDefault: () => {} });
            if (others.length > 0) handleAddAnexos({ target: { files: others }, preventDefault: () => {} });
          }
        }}
      >
        <div className="anexos-header">
          <div className="anexos-botoes">
            <label htmlFor="fileInputAnexo" className={`upload-btn checklist-btn${isUploading ? ' upload-btn--disabled' : ''}`}>
              Anexo
            </label>
            <input type="file" id="fileInputAnexo" hidden multiple onChange={handleAddAnexos} disabled={loading || isUploading} />

            <label htmlFor="fileInputImagem" className={`upload-btn checklist-btn${isUploading ? ' upload-btn--disabled' : ''}`}>
              Imagens
            </label>
            <input type="file" id="fileInputImagem" hidden multiple accept="image/*" onChange={handleAddImagens} disabled={loading || isUploading} />

            <button
              type="button"
              className={`upload-btn checklist-btn ${objetivos.length > 0 ? 'checklist-btn--active' : ''}`}
              onClick={() => setShowObjetivos(!showObjetivos)}
              disabled={loading}
              title={showObjetivos ? "Ocultar objetivos" : "Ver objetivos"}
            >
              Objetivos
              {!showObjetivos && objetivos.length > 0 && (
                <span className="checklist-badge">{objetivos.length}</span>
              )}
            </button>

            <button
              type="button"
              className={`upload-btn checklist-btn ${compromissosCount > 0 ? 'checklist-btn--active' : ''}`}
              onClick={() => setShowCompromissos(!showCompromissos)}
              disabled={loading}
              title={showCompromissos ? "Ocultar compromissos" : "Ver compromissos"}
            >
              Compromissos
              {!showCompromissos && compromissosCount > 0 && (
                <span className="checklist-badge">{compromissosCount}</span>
              )}
            </button>
          </div>
        </div>

        {uploadingImages.length > 0 && (
          <div className="imagens-miniaturas">
            {uploadingImages.map(p => (
              <MiniaturaLoading key={p.tempId} fileName={p.fileName} />
            ))}
          </div>
        )}

        {imagens.length > 0 && (
          <div className="imagens-miniaturas">
            {imagens.map(anexo => (
              <div key={`img-${anexo.id}`} className="miniatura-item">
                <img
                  src={anexo.file_url}
                  alt={anexo.file_name}
                  onClick={() => {
                    const index = imagens.findIndex(img => img.id === anexo.id);
                    setImagemAmpliada({ index, imagens });
                  }}
                  loading="lazy"
                />
                <button
                  className="botao-lixeira-miniatura"
                  onClick={(e) => { e.stopPropagation(); handleRemoverAnexo(anexo.id, anexo.file_url); }}
                  aria-label="Excluir imagem"
                >
                  <FaTrashAlt size={12} />
                </button>
              </div>
            ))}
          </div>
        )}

        {uploadingFiles.length > 0 && (
          <div className="anexos-lista" style={{ marginBottom: 6 }}>
            {uploadingFiles.map(p => (
              <AnexoLoading key={p.tempId} fileName={p.fileName} />
            ))}
          </div>
        )}

        <div className="anexos-lista">
          {anexosSalvos
            .filter(a => !a.mime_type?.startsWith('image/'))
            .map(anexo => (
              <div key={anexo.id} className="anexo-item">
                <a href={anexo.file_url} target="_blank" rel="noopener noreferrer">
                  {anexo.file_name}
                </a>
                <button type="button" title="Remover" onClick={() => handleRemoverAnexo(anexo.id, anexo.file_url)} disabled={loading}>×</button>
              </div>
            ))}
        </div>

        <div className="drag-hint">
          Arraste arquivos aqui para anexar (imagens ou documentos)
        </div>
      </div>

       {/* ← PATCH 5 - Compromissos */}
      {showCompromissos && notaAtual?.id && (
        <TaskCompromissos
          notaId={notaAtual.id}
          usuarioId={userId}
          containerId={containerId}
          onNovoComentario={onNovoComentario}
        />
      )}

      {/* ── Objetivos (estilo AtaObjetivos) ── */}
      {showObjetivos && (
        <div className="ata-section">
          <div className="ata-objectives">

            <div className="objetivos-header">
              <div className="objetivos-header-titulo">
                <FontAwesomeIcon icon={faTasks} />
                <span>Lista de objetivos</span>
                <span className="objetivos-contador">
                  ({objetivos.length} · {objetivos.filter(o => o.concluido).length} concluídos)
                </span>
              </div>
              <button
                className={`btn-ordem-objetivos ${ordemDesc ? 'ordem-desc' : 'ordem-asc'}`}
                onClick={() => setOrdemDesc(prev => !prev)}
                title={ordemDesc ? "Mais recentes primeiro" : "Mais antigos primeiro"}
              >
                <svg width="13" height="13" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  {ordemDesc ? (<><line x1="5" y1="2" x2="5" y2="14"/><polyline points="2,10 5,14 8,10"/><line x1="11" y1="14" x2="11" y2="2" strokeOpacity="0.3"/><polyline points="8,6 11,2 14,6" strokeOpacity="0.3"/></>) : (<><line x1="5" y1="14" x2="5" y2="2" strokeOpacity="0.3"/><polyline points="2,6 5,2 8,6" strokeOpacity="0.3"/><line x1="11" y1="2" x2="11" y2="14"/><polyline points="8,10 11,14 14,10"/></>)}
                </svg>
              </button>
            </div>

            <div className="progress-segmentada-wrap">
              <div className="progress-segmentada">
                {objetivos.map(o => (
                  <div key={o.id} className={`progress-segmento ${o.concluido ? 'preenchido' : ''}`} title={o.texto} />
                ))}
                {objetivos.length === 0 && <div className="progress-segmento progress-segmento--vazio" />}
              </div>
              <span className="progress-segmentada-percent">{progressoPercent}%</span>
            </div>

            {notaAtual?.id && containerId ? (
              <div className="objetivos-add-form">
                <input
                  type="text"
                  value={novoObjetivoTexto}
                  onChange={(e) => setNovoObjetivoTexto(e.target.value)}
                  placeholder="Digite um novo objetivo..."
                  onKeyDown={(e) => e.key === "Enter" && adicionarObjetivo()}
                  disabled={loading}
                />
                <button type="button" className="objetivos-add-btn" onClick={adicionarObjetivo} disabled={!novoObjetivoTexto.trim() || loading}>
                  Adicionar
                </button>
              </div>
            ) : (
              <div className="objetivos-add-form">
                <input type="text" placeholder="Carregando..." disabled />
                <button type="button" className="objetivos-add-btn" disabled>Adicionar</button>
              </div>
            )}

            <div className="objetivos-scroll">
              <DragDropContext onDragEnd={handleDragEnd}>
                <Droppable droppableId="task-objetivos-list">
                  {(provided) => (
                    <div className="objetivos-list-inner" ref={provided.innerRef} {...provided.droppableProps}>
                      {(ordemDesc ? [...objetivosFiltrados].reverse() : [...objetivosFiltrados]).map((o, filtroIdx) => {
                        const i = objetivos.findIndex(obj => obj.id === o.id);
                        if (i === -1) return null;
                        const isConcluido   = o.concluido;
                        const podeDesmarcar = podeDesmarcarConclusao(o.concluidoEm);
                        const comentarios   = comentariosObjetivo[o.id] || [];
                        const hasComments   = comentarios.length > 0;

                        return (
                          <Draggable key={String(o.id)} draggableId={String(o.id)} index={filtroIdx} isDragDisabled={isConcluido}>
                            {(provided, snapshot) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                className={`obj-card ${isConcluido ? 'obj-card--concluido' : ''} ${snapshot.isDragging ? 'obj-card--dragging' : ''}`}
                                style={{ ...provided.draggableProps.style, opacity: snapshot.isDragging ? 0.85 : 1 }}
                              >
                                <div className="obj-linha1">
                                  <input
                                    type="checkbox"
                                    checked={isConcluido}
                                    onChange={() => toggleConclusao(o.id, o.concluido)}
                                    disabled={isConcluido && !podeDesmarcar}
                                    onClick={e => e.stopPropagation()}
                                    className="obj-checkbox"
                                  />
                                  <span className={`obj-texto ${isConcluido ? 'obj-texto--concluido' : ''}`}>
                                    <strong className="obj-num">{i + 1}.</strong> {o.texto}
                                  </span>

                                  <div className="obj-acoes-dir">
                                    {!isConcluido && (
                                      <span className="obj-icon-btn" title="Editar" onClick={e => {
                                        e.stopPropagation();
                                        const novoTexto = prompt("Editar objetivo:", o.texto);
                                        if (novoTexto !== null && novoTexto.trim() !== "" && novoTexto.trim() !== o.texto) {
                                          setObjetivos(prev => prev.map(item => item.id === o.id ? { ...item, texto: novoTexto.trim() } : item));
                                          supabase.from("checklist_items").update({ description: novoTexto.trim() }).eq("id", o.id)
                                            .then(({ error }) => { if (error) { alert("Erro ao salvar."); setObjetivos(prev => prev.map(item => item.id === o.id ? { ...item, texto: o.texto } : item)); } });
                                        }
                                      }}>
                                        <FontAwesomeIcon icon={faPenToSquare} />
                                      </span>
                                    )}

                                    <div style={{ position: 'relative' }}>
                                      <ComentarioIcon onClick={() => setEditandoComentario(prev => ({ ...prev, [i]: !prev[i] }))} title={hasComments ? "Ver comentários" : "Comentar"} hasComments={hasComments} />
                                      {editandoComentario[i] && (
                                        <div className="comentario-chat-container">
                                          <div className="comentario-input-area">
                                            <input type="text" value={comentarioTemp[o.id] || ""} onChange={e => setComentarioTemp(prev => ({ ...prev, [o.id]: e.target.value }))} placeholder="Adicionar comentário..." className="comentario-input" disabled={enviandoComentario[o.id]}
                                              onKeyDown={e => { if (e.key === "Enter" && !e.shiftKey && !enviandoComentario[o.id]) { e.preventDefault(); enviarComentario(o.id); } }} />
                                            <button onClick={() => enviarComentario(o.id)} className="btn-enviar-comentario" disabled={!comentarioTemp[o.id]?.trim() || enviandoComentario[o.id]}>
                                              {enviandoComentario[o.id] ? <span className="spinner-comentario" /> : <FontAwesomeIcon icon={faPaperPlane} />}
                                            </button>
                                          </div>
                                          {comentarios.length > 0 && (
                                            <div className="comentarios-lista">
                                              {comentarios.map((c, idx) => {
                                                const isTemp = String(c.id).startsWith('temp-');
                                                const souAutor = c.usuario_id === userId;
                                                return (
                                                  <div key={`${c.id}-${idx}`} className={`comentario-item ${isTemp ? 'comentario-temporario' : ''}`}>
                                                    <div className="comentario-item-header">
                                                      <span className="comentario-autor">{c.profiles?.nome || "Usuário"}</span>
                                                      {souAutor && !isTemp && (
                                                        <button className="comentario-excluir-btn" onClick={() => removerComentario(c, o.id)} title="Excluir comentário">×</button>
                                                      )}
                                                    </div>
                                                    <div className="comentario-texto">{c.comentario}</div>
                                                    <div className="comentario-data">
                                                      {isTemp ? <span style={{ fontStyle: 'italic', color: '#9ca3af' }}>Enviando...</span> : new Date(c.created_at).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                                                    </div>
                                                  </div>
                                                );
                                              })}
                                            </div>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>

                                {(!isConcluido || (o.responsaveis || []).length > 0) && (
                                  <div className="obj-linha2">
                                    <div className="obj-chips-wrap">
                                      {(o.responsaveis || []).map((resp, respIdx) => (
                                        <ChipResponsavel key={`${o.id}-${resp.id}-${respIdx}`} responsavel={resp} onRemove={r => removerResponsavel(r.id, o.id)} disabled={isConcluido} />
                                      ))}
                                      {!isConcluido && (
                                        <span className="obj-add-resp-btn" title="Adicionar responsável"
                                          onClick={e => { e.stopPropagation(); setEditingResponsavelId(prev => prev === o.id ? null : o.id); }}>
                                          <FontAwesomeIcon icon={faUserPlus} />
                                        </span>
                                      )}
                                    </div>

                                    {editingResponsavelId === o.id && !isConcluido && (
                                      <div className="input-responsavel-flutuante">
                                        <input
                                          type="text"
                                          autoFocus
                                          placeholder="Nome ou @menção"
                                          value={inputResponsavel[o.id] || ""}
                                          onChange={(e) => handleResponsavelInputChange(e, o.id)}
                                          onBlur={() => setTimeout(() => setEditingResponsavelId(null), 200)}
                                          onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                              e.preventDefault();
                                              const valor = inputResponsavel[o.id] || "";
                                              if (!valor.startsWith("@")) { adicionarResponsavelExterno(valor, o.id); setEditingResponsavelId(null); }
                                            } else if (e.key === "Escape") { setEditingResponsavelId(null); }
                                          }}
                                          disabled={loading}
                                        />
                                        {sugestoesResponsavel[o.id]?.length > 0 && (
                                          <div className="sugestoes-list-flutuante">
                                            {sugestoesResponsavel[o.id].map(item => (
                                              <div key={item.id} className="sugestao-item" onClick={() => { adicionarResponsavelInterno(item, o.id); setEditingResponsavelId(null); }}>
                                                @{item.nickname || item.nome}
                                              </div>
                                            ))}
                                          </div>
                                        )}
                                      </div>
                                    )}

                                    {!isConcluido && (
                                      <>
                                        <div className="obj-data-label" onClick={e => e.stopPropagation()}>
                                          {o.dataEntrega ? <span className="obj-data-texto">{formatarDataParaExibicao(o.dataEntrega)}</span> : null}
                                          <FontAwesomeIcon icon={faCalendar} className="obj-data-icon" />
                                          <input
                                            type="date"
                                            className="obj-date-trigger"
                                            value={o.dataEntrega || ''}
                                            onClick={e => e.stopPropagation()}
                                            onChange={(e) => atualizarDataEntrega(o.id, e.target.value || null)}
                                            disabled={loading}
                                          />
                                        </div>

                                        {(reprogramacoesPorObjetivo[o.id] || []).length > 0 && (
                                          <div style={{ position: 'relative' }}>
                                            <span
                                              className="obj-icon-btn"
                                              title="Histórico de reprogramação"
                                              onClick={e => { e.stopPropagation(); setHistoricoAberto(prev => ({ ...prev, [o.id]: !prev[o.id] })); }}
                                            >
                                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
                                                <path d="M3 3v5h5" />
                                                <path d="M12 7v5l4 2" />
                                              </svg>
                                            </span>
                                            {historicoAberto[o.id] && (
                                              <div className="menu-historico-reprog">
                                                <div className="menu-historico-header">
                                                  <span>Histórico de reprogramação</span>
                                                  <button onClick={e => { e.stopPropagation(); setHistoricoAberto(prev => ({ ...prev, [o.id]: false })); }}>×</button>
                                                </div>
                                                {reprogramacoesPorObjetivo[o.id].map(r => (
                                                  <div key={r.id} className="menu-historico-item">
                                                    {r.data_anterior ? r.data_anterior.split('-').reverse().join('/') : '—'}
                                                  </div>
                                                ))}
                                              </div>
                                            )}
                                          </div>
                                        )}

                                        <span className="obj-btn-excluir" title="Excluir objetivo"
                                          onClick={e => { e.stopPropagation(); removerObjetivo(o.id); }}>
                                          ×
                                        </span>
                                      </>
                                    )}
                                  </div>
                                )}
                              </div>
                            )}
                          </Draggable>
                        );
                      })}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </div>
            

            {(todosResponsaveis.length > 0 || objetivos.length > 0) && (
              <div className="objetivos-footer-filtro">
                <div className="objetivos-footer-filtro-esquerda">
                  <svg className={`icone-filtro-objetivos ${filtroResponsavel ? 'icone-filtro-ativo' : ''}`}
                    width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
                    strokeLinecap="round" strokeLinejoin="round" title="Filtrar por responsável">
                    <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
                  </svg>
                  {todosResponsaveis.map(resp => {
                    const key = resp.usuario_id || resp.nome_externo;
                    const isAtivo = filtroResponsavel === key;
                    const nomeExibicao = resp.nome_exibicao || resp.nome_externo || "Usuário";
                    return (
                      <div key={key}
                        className={`filtro-avatar-wrapper ${isAtivo ? 'filtro-avatar-ativo' : ''}`}
                        title={`Filtrar por ${nomeExibicao}`}
                        onClick={() => setFiltroResponsavel(prev => prev === key ? null : key)}
                      >
                        {resp.avatar_url ? <img src={resp.avatar_url} alt={nomeExibicao} className="filtro-avatar-img" onError={e => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }} /> : null}
                        <div className="filtro-avatar-iniciais" style={{ display: resp.avatar_url ? 'none' : 'flex' }}>{gerarAbreviacao(nomeExibicao)}</div>
                        {isAtivo && <div className="filtro-avatar-badge" />}
                      </div>
                    );
                  })}
                  {filtroResponsavel && <button className="filtro-limpar-btn" onClick={() => setFiltroResponsavel(null)}>✕</button>}
                </div>

                <div className="filtro-status-wrap" ref={filtroStatusRef}>
                  <button
                    className={`filtro-sem-resp-btn ${filtroStatus ? 'ativo' : ''}`}
                    onClick={() => setFiltroStatusAberto(prev => !prev)}
                  >
                    <span>Filtro de status</span>
                    {filtroStatus && <span className="filtro-status-badge" />}
                  </button>

                  {filtroStatusAberto && (
                    <div className="filtro-status-flutuante">
                      <button
                        className={`filtro-status-item ${filtroStatus === "concluidos" ? 'ativo' : ''}`}
                        onClick={() => { setFiltroStatus(prev => prev === "concluidos" ? null : "concluidos"); setFiltroStatusAberto(false); }}
                      >
                        Concluídos
                      </button>
                      <button
                        className={`filtro-status-item ${filtroStatus === "nao_respondidos" ? 'ativo' : ''}`}
                        onClick={() => { setFiltroStatus(prev => prev === "nao_respondidos" ? null : "nao_respondidos"); setFiltroStatusAberto(false); }}
                      >
                        Não respondidos
                      </button>
                      <button
                        className={`filtro-status-item ${filtroStatus === "sem_resp" ? 'ativo' : ''}`}
                        onClick={() => { setFiltroStatus(prev => prev === "sem_resp" ? null : "sem_resp"); setFiltroStatusAberto(false); }}
                      >
                        Sem responsáveis
                      </button>
                      {filtroStatus && (
                        <button className="filtro-status-item filtro-status-item--limpar" onClick={() => { setFiltroStatus(null); setFiltroStatusAberto(false); }}>
                          Limpar ✕
                        </button>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}

          </div>
        </div>
      )}

     
    </>
  );
};

export default TaskAnexos;